import useOnLayerAfterSet from "../../../layer/observable/useOnLayerAfterSet";
import useWeakMap from "../../../utils/useWeakMap";
import { runExtractValue } from "../../executor";
import { convertToPropAccessByBracket, extractContentByTag } from "../../util";
import { canBindingNode } from "../useBinding";
import useWatcher from "../useWatcher";

const getReplacementText = (props, originText, replacements) => replacements.reduce((text, item) => {
    const [searchText, propText] = item;
    const propValue = runExtractValue(props, propText);
    return text.replace(searchText, propValue);
}, originText)


const useInterpolationForText = (() => {

    const caching = useWeakMap();

    const isTextNode = (node) => node.nodeName === '#text';

    /**
     * @param {Node} node
     * @param {object} props
     */
    const render = (node, props) => {
        if (!canBindingNode(node)) return;
        if (!caching.has(node)) return;
        const attrListing = caching.get(node);
        attrListing.forEach(({ text, interpolations }) => {
            for (let i in interpolations) {
                const { node, originText, replacements } = interpolations[i];
                node.textContent = getReplacementText(props, originText, replacements);
            }
        })
    }

    /** 
     * @param {Node} node
     * @returns { Array<{ node:Node , originText:string, replacements: Array<[searchText,propText]> }> } 
     * */
    const extractInterpolationFromTextNode = (node) => {
        const textNodes = Array.from(node.childNodes).filter(isTextNode);

        return textNodes.reduce((out, target) => {
            const list = extractContentByTag(target.textContent);
            if (list.length > 0) {
                out.push({
                    node: target,
                    originText: target.textContent,
                    replacements: list || []
                })
            }
            return out;
        }, []);
    }

    return (props, node) => {
        const interpolations = extractInterpolationFromTextNode(node);
        if (interpolations.length === 0) {
            return Promise.resolve()
        }
        // debugger
        if (!caching.has(node)) {
            caching.set(node, []);
        }
        const listing = caching.get(node);
        listing.push({ text: node.textContent, interpolations });
        const propNameDeps = interpolations.reduce((out, item) => {
            for (let i in item.replacements) {
                if (item.replacements[i][1]) {
                    out.add(item.replacements[i][1]);
                }
            }
            return out;
        }, new Set());


        const { onPropChanges, onDestroy, getSource } = useWatcher(props, node, Array.from(propNameDeps));

        onPropChanges(() => {
            render(node, getSource())
        })

        onDestroy(() => {
            caching.delete(node);
        })
        return Promise.resolve();
    }
})();

export default useInterpolationForText;